export default __webpack_public_path__ + "static/media/FOOD TRUCK - Gumbo Mambo - PNG for movement.5cb4cdd9.png";